/** Project phase contract (RBAC area: `projects`). Ordered phases within a project. */
export const PROJECT_PHASE_STATUSES = ['active', 'completed'];
//# sourceMappingURL=project-phase.js.map